import React from 'react';
import { Link } from 'wouter';
import { Home, Search, ArrowRight } from 'lucide-react';
import { SEO } from '../components/SEO';
import { Navigation } from '../components/Layout/Navigation';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <SEO
        title="Page Not Found | btoolme"
        description="The page you're looking for doesn't exist. Find the perfect business tools for your needs at btoolme."
        path="/404"
        noindex={true}
      />

      <Navigation />

      <div className="max-w-2xl mx-auto px-4 py-16 sm:py-24 text-center">
        <div className="mb-8">
          <span className="text-8xl font-bold text-gray-200">404</span>
        </div>

        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
          Page Not Found
        </h1>

        <p className="text-lg text-gray-600 mb-8">
          Sorry, we couldn't find the page you're looking for. It may have been moved or doesn't exist.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link href="/">
            <a className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              <Home className="w-5 h-5 mr-2" />
              Go Home
            </a>
          </Link>

          <Link href="/directory">
            <a className="inline-flex items-center justify-center px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
              <Search className="w-5 h-5 mr-2" />
              Browse Tools
            </a>
          </Link>
        </div>

        <div className="mt-12 p-6 bg-blue-50 rounded-xl border border-blue-100">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Looking for software recommendations?
          </h2>
          <p className="text-gray-600 mb-4">
            Get personalized tool recommendations for your business in just 3 minutes.
          </p>
          <Link href="/questionnaire">
            <a className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium">
              Start Questionnaire
              <ArrowRight className="w-4 h-4 ml-2" />
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}
